import { httpService } from '~/Services/Service';

// W-0804 — Acordos de cobrança não concretizados (relatório read-only).
// Fonte BE: AcordosNaoConcretizadosController ([RoutePrefix] api/cobranca/acordos-nao-concretizados).
// httpService já desembrulha .data — o valor resolvido é o payload direto.

// T1 — relatório consolidado (GET + query string; período obrigatório).
export const listarAcordosNaoConcretizados = (params) =>
  httpService.get('/cobranca/acordos-nao-concretizados', { params });

// T2 — combo cobrador (escopo sojuris/pezao derivado no Service do backend).
export const listarCobradores = () =>
  httpService.get('/cobranca/acordos-nao-concretizados/cobradores');

// T3 — combo empreendimento.
export const listarEmpreendimentos = () =>
  httpService.get('/cobranca/acordos-nao-concretizados/empreendimentos');
